<template lang="pug">
    v-container(fluid)
      div
        v-data-table(
            :headers="shareHeader"
            :items="getShareData"
            :loading="loadingShares"
            single-expand
            item-key="id"
            show-expand
            class="elevation-1"
        )
            template(v-slot:expanded-item="{ headers, item }")
                td(:colspan="headers.length").pb-4 
                    div.mt-3 
                        p().font-weight-bold Viewer details
                    div.mt-n1
                        div(v-for="(view, n) in item.emailsAndCount" :key="n")
                            span {{ view.email }}
                            span(v-if="view.count > 1").ml-1 x{{ view.count }}


</template>

<script>
import { ActivityLogType, useActivityLogsQuery } from "@/graphql/jarvis";
import { groupBy } from "lodash";

export default {
  data() {
    return {
      shareBriefingQueryVariables: {
        filter: {
          and: [
            {
              type: {
                eq: ActivityLogType.Externalsharerequest,
              },
            },
            {
              referenceEntity: {
                eq: "Briefing",
              },
            },
          ],
        },
      },
      loadingShares: false,
      shareHeader: [
        {
          text: "Briefing",
          align: "start",
          sortable: false,
          value: "title",
        },
        { text: "No of Views", value: "noOfViews", align: "end" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  computed: {
    activityLogsComputed() {
      return this.activityLogs?.edges || [];
    },
    getShareData() {
      const data = this.activityLogsComputed;
      const groupByPostIds = groupBy(data, (x) => {
        let referenceId = x?.node?.referenceId || "";
        referenceId = referenceId.split("/")[0];
        return referenceId;
      });
      const results = [];
      for (const key in groupByPostIds) {
        const items = groupByPostIds?.[key] || [];
        const details = JSON.parse(items?.[0]?.node?.details || "{}");
        const title = details?.title;
        const emailsAndCount = {};
        for (const item of items) {
          const details = JSON.parse(item?.node?.details || "{}");
          const email = details?.email || null;
          if (!email) continue;
          emailsAndCount[email] = (emailsAndCount?.[email] || 0) + 1;
        }
        const item = {
          id: key,
          title,
          noOfViews: items.length,
          emailsAndCount: Object.keys(emailsAndCount).reduce((acc, curr) => {
            acc.push({
              email: curr,
              count: emailsAndCount[curr],
            });
            return acc;
          }, []),
        };
        results.push(item);
      }
      return results;
    },
  },
  apollo: {
    activityLogs: {
      ...useActivityLogsQuery({
        variables: function () {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore: Unreachable code error
          return this.shareBriefingQueryVariables;
        },
      }),
      watchLoading(isLoading) {
        this.$store.commit("queryLoading", isLoading);
        this.loadingShares = isLoading;
      },
      skip: () => {
        return this === null;
      },
    },
  },
};
</script>
